import { Injectable } from '@angular/core';
import {HttpParams} from '@angular/common/http';
import {empresa} from '../models/empresa';
import {HttpClientService} from "./http-client.service";

@Injectable({
  providedIn: 'root'
})
export class EmpresaService {

  constructor(private http: HttpClientService) { }

  public getAll() {
    return this.http.get('/empresa/getall');
  }

  public getById(idEmpresa: string) {
    let params = new HttpParams().set("idEmpresa", idEmpresa);
    return this.http.getWithParams('/empresa/getbyid', params);
  }

  public new(empresa: empresa) {
    return this.http.post('/empresa/new', empresa);
  }

  public delete(id: string) {
    return this.http.delete('/empresa/delete/' + id);
  }

}
